import Selectr from "mobius1-selectr";


const MVEditor = {
    phoneSelectTypeRender(option) {
        var template = [
            '<svg class="bi" width="18" height="18" fill="currentColor">',
            `<use xlink:href="#bs-icon-${option.dataset.bsicon}"/>`,
            '</svg>'
        ];
        return template.join('');
    },

    initPhoneTypeSelectrs($editorPart) {
        let $phoneSelectors = $editorPart.find('> .input-group:not(.with-phone-select-init) .phone-type-select');
        
        if($phoneSelectors.length > 0){
            $phoneSelectors.each((key, el) => {
                $(el).closest('.input-group').addClass('with-phone-select-init');
                let selector = new Selectr(el, {
                    //customClass: "custom-select",
                    searchable: false,
                    width: 50,
                    renderOption: this.phoneSelectTypeRender,
                    renderSelection: this.phoneSelectTypeRender
                });
                
                let currentCont = null;
                let currentNewCont = null;

                selector.on('selectr.open', function(a,b,c) {
                    
                    let optsList = this.tree;
                    let $cont = $(optsList).parent();
                    
                    if($cont.closest('td').length > 0){
                        // Only run in table
                        currentCont = $cont;
                        let $from = $cont.parent();

                        $from.addClass('detached-cont');

                        whenVisible($from[0], function () {
                            let offset = $cont.offset();
                            let width = $cont.closest('.selectr-container').width();
                            let classesParent = $cont.closest('.selectr-container').attr('class');
                            let newCont = $(`<div class="${classesParent}"></div>`);
                            currentNewCont = newCont;

                            newCont.appendTo('body');

                            $cont.appendTo(newCont);

                            $cont.data('from', $from);

                            newCont.css({
                                position: 'absolute',
                                left: offset.left,
                                top: offset.top,
                                width: width
                            });
                        })
                    }
                    
                });
                selector.on('selectr.close', function() {
                    if(currentNewCont){
                        let deTk = $('.selectr-container.detached-cont');
                        deTk.removeClass('detached-cont');
                        currentCont.insertAfter(deTk.find('.selectr-selected'));
                        currentNewCont.remove();
                        currentNewCont = null;
                    }
                });
            });
        }
        
        function whenVisible(element, callback) {
            
            var observer = new MutationObserver(function(){
                if(element.classList.contains('open')){
                    observer.disconnect();
                    callback()
                }
            });
            
            observer.observe(element, { attributes: true, childList: true });
        }
    },
    
    initBtns($editorPart){
        $editorPart
            .on('click', 'button[data-remove-field]', function () {
                $(this).closest('.input-group').remove()
            })
            .on('click', 'button[data-inline-add-row]', function () {
                let template = $editorPart.find('.inputTemplate').html();
                $editorPart.append(template);

                MVEditor.initPhoneTypeSelectrs($editorPart)
            })
    },
    
    collectPhones($editorPart) {
        let values = [];
        let $valuesEl = $editorPart.find('> .input-group.with-phone-select-init');
        $valuesEl.each(function (num, el) {
            values.push( {
                type: $(el).find('select.phone-type-select').val(),
                number: $(el).find('input').val(),
            } );
        });
        
        return values;
    },

    collectValues($editorPart) {
        if(! $editorPart){
            return null;
        }
        let values = [];
        let $valuesEl = $editorPart.find('> .input-group > input.form-control');
        $valuesEl.each(function (num, el) {
            values.push( $(el).val() );
        });
        
        return values;
    },
};

(function () {
    
    // Auto run

})();


export { MVEditor };
